import pathsCashbox from '~/util/router/pathsCashbox'
import pathsCore from '~/util/router/pathsCore'
import pathsGameCategories from '~/util/router/pathsGameCategories'
import pathsPrivate from '~/util/router/pathsPrivate'
import pathsPromotions from '~/util/router/pathsPromotions'
import pathsProfile from '~/util/router/pathsProfile'

export const paths = {
  ...pathsCore,
  ...pathsPromotions,
  ...pathsGameCategories,
  ...pathsCashbox,
  ...pathsProfile,
  ...pathsPrivate,

  // jurisprudence
  rules: {
    path: '/rules',
    title: {
      ru: 'Правила и условия',
      ua: 'Правила та умови',
    },
  },
  gameRules: {
    path: '/game-rules',
    title: {
      ru: 'Правила игры',
      ua: 'Правила гри',
    },
  },
  policy: {
    path: '/privacy-policy',
    title: {
      ru: 'Политика конфиденциальности',
      ua: 'Політика конфіденційності',
    },
  },
  responsibleGaming: {
    path: '/responsible-gaming',
    title: {
      ru: 'Ответственная игра',
      ua: 'Відповідальна гра',
    },
  },
  intellectualProperty: {
    path: '/intellectual-property',
    title: {
      ru: 'Интелектуальная собственность',
      ua: 'Інтелектуальна власність',
    },
  },
  license: {
    path: '/license',
    title: {
      ru: 'Лицензия',
      ua: 'Ліцензія',
    },
  },
  partners: {
    path: '/partners',
    title: {
      ru: 'Партнерам',
      ua: 'Партнерам',
    },
  },
  amlpolicy: {
    path: '/amlpolicy',
    title: {
      ru: 'AML Policy',
      ua: 'AML Policy',
    },
  }, 
}
